import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-imageviewer',
  templateUrl: './imageviewer.page.html',
  styleUrls: ['./imageviewer.page.scss'],
})
export class ImageViewerPage implements OnInit {

  img: any;
  imgs: any;
  studentId;
  apikey;
  @ViewChild('slider', { read: ElementRef, static: true }) slider: ElementRef;

  sliderOpts = {
    zoom: {
      maxRatio: 5
    }
  };

  constructor(
    private navParams: NavParams,
    private modalController: ModalController,
    public dataSvc: DataService,
    public router: Router,
    public commonSvc: CommonService,
  ) { }

  ngOnInit() {
    this.getStudentId().then(() => {
      if (this.studentId > 0) {
        this.img = this.navParams.get('img');
        this.imgs = this.dataSvc.getParamData();
      } else {
        this.router.navigate(['/login']);
        return false;
      }
    });
  }
  async getStudentId() {
    this.studentId = + await this.commonSvc.getItem('studentid');
    this.apikey = await this.commonSvc.getItem('apikey');
  }
  zoom(zoomIn: boolean) {
    const zoom = this.slider.nativeElement.swiper.zoom;
    if (zoomIn) {
      zoom.in();
    } else {
      zoom.out();
    }
  }

  close() {
    this.modalController.dismiss();
  }

  openfacebook() {
    // window.open('fb://facebook.com/latechnologies', '_system', 'location=yes');
    window.open('https://www.facebook.com/');
  }
  opentwitter() {
    window.open('https://www.twitter.com/');
  }
  openinstagram() {
    window.open('https://www.instagram.com/');
  }
}
